import { CompanyCandidate, CompetencyMap, Examination, Trial } from "@generated/graphql";
import dayjs from "dayjs";

interface GetTrialFileNameParams {
  trial?: Pick<Trial, "completedAt">;
  examination?: Pick<Examination, "title" | "numericId">;
  competencyMap?: Pick<CompetencyMap, "title">;
  companyCandidate?: Pick<CompanyCandidate, "fullName">;
}

// eslint-disable-next-line import/prefer-default-export
export const getTrialFileName = ({ trial, examination, competencyMap, companyCandidate }: GetTrialFileNameParams) =>
  // eslint-disable-next-line max-len
  `${examination?.title ? `${examination.title}_` : ""}${companyCandidate?.fullName ? `${companyCandidate.fullName}_` : ""}${competencyMap?.title ? `${competencyMap.title}_` : ""}${examination?.numericId ? `${examination.numericId}_` : ""}${trial?.completedAt ? dayjs(trial.completedAt).format("DD.MM.YYYY") : ""}.pdf`;
